import { map, toNumber } from 'lodash';

import {
  FullBOUserResponseModel,
  InternationalRequestModel,
  ProfileTypeEnum,
} from 'api/backofficeApiClient';

export interface InternationalProfileFormValues {
  ownerInfo: {
    firstName: string;
    lastName: string;
    email: string;
  };
  bestContact: {
    sameAsOwner: boolean;
    firstName?: string;
    lastName?: string;
  };
  emailForCommunications: {
    sameAsOwner: boolean;
    email?: string;
  };
  businessName: string;
  businessPhone: string;
  country?: number;
  state?: number;
  internationalStateName?: string;
  city: string;
  internationalCityName?: string;
  address: string | null;
  zip: string;
  businessEmail?: string;
  industry: string[];
  assignmentLocations?: number[] | null;
  assignment?: boolean;
  termsAndConditions?: boolean;
  isRegisteredOnMarketPlace?: boolean;
  website?: string;
}

export const mapInternationProfileToRequest = (
  values: InternationalProfileFormValues,
  profileInfo?: FullBOUserResponseModel,
): InternationalRequestModel => {
  const {
    ownerInfo,
    bestContact,
    emailForCommunications,
    businessName,
    businessPhone,
    country,
    city,
    address,
    zip,
    industry,
    assignmentLocations,
    assignment,
    website,
    businessEmail,
    state,
    internationalStateName,
    internationalCityName,
  } = values;

  const isCorporateTAProfileType =
    profileInfo?.profileType === ProfileTypeEnum.Corporate;

  return {
    website: website || undefined,
    ownerInfo: {
      firstName: ownerInfo.firstName.trim(),
      lastName: ownerInfo.lastName.trim(),
      email: ownerInfo.email.trim(),
    },
    bestContact: {
      firstName: bestContact.sameAsOwner
        ? ownerInfo.firstName.trim()
        : bestContact.firstName?.trim(),
      lastName: bestContact.sameAsOwner
        ? ownerInfo.lastName.trim()
        : bestContact.lastName?.trim(),
      email: emailForCommunications.sameAsOwner
        ? ownerInfo.email.trim()
        : emailForCommunications.email?.trim(),
    },
    businessInfo: {
      name: businessName.trim(),
      phoneNumber: businessPhone.trim(),
      location: {
        countryId: toNumber(country),
        city: city.trim(),
        address: address?.trim(),
        zipCode: zip?.trim() || undefined,
        stateId: state || undefined,
        internationalStateName: internationalStateName || undefined,
        internationalCityName: internationalCityName?.trim() || undefined,
      },
      businessEmail: isCorporateTAProfileType
        ? businessEmail?.trim()
        : undefined,
      industry,

      // for edit we need pass those two fields too, because it is required in api always
      assignmentLocations:
        (!!profileInfo?.businessInfo
          ? (map(
              profileInfo?.businessInfo?.assignmentLocations,
              'id',
            ) as number[])
          : assignmentLocations) || undefined,
      assignment: !!profileInfo?.businessInfo
        ? profileInfo?.businessInfo?.assignment
        : assignment,
    },
    companyId: profileInfo?.companyId || undefined,
  };
};
